import { useMemo } from 'react';

export const useIsMobileBrowser = () => {
  const isMobileBrowser = useMemo(() => {
    const userAgent =
      typeof navigator !== 'undefined' ? navigator.userAgent : '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  }, []);

  return isMobileBrowser;
};
